import { ApiError } from '@/api/client';

export type LoginErrorSeverity = 'error' | 'warning';

export interface LoginErrorInfo {
  message: string;
  severity: LoginErrorSeverity;
}

type TranslateFn = (key: string) => string;

/**
 * Login-hiba → differenciált üzenet + severity.
 *
 * A 54Y auth-batch RLS-ENABLE (23 tábla) óta a fail-closed hibamód éles: egy törött
 * tenant-kontextus vagy rendszerhiba a loginnál NEM keverendő a rossz jelszóval — különben
 * a user a saját jelszavát hibáztatja, újrapróbálkozik → lockout egy hibátlan fiókon.
 *
 * Reuse-minta: `api/deposits.ts` depositActionErrorToastKey — ApiError → statusCode-elágazás
 * → nem-ApiError (hálózati) fallback.
 *
 * - 401 / 403      → hibás belépési adat (piros — a user hibája, javítsa)
 * - 429            → túl sok próbálkozás (amber — a lockout-hibamód közvetlen tükre)
 * - >= 500         → átmeneti rendszerhiba (amber — a fail-closed RLS/backend-hiba, NEM a jelszó)
 * - egyéb 4xx      → a backend-üzenet, ha van, különben generikus (piros)
 * - nem-ApiError   → kapcsolat-/hálózati hiba (amber)
 */
export function loginErrorInfo(err: unknown, t: TranslateFn): LoginErrorInfo {
  if (err instanceof ApiError) {
    const status = err.statusCode;
    if (status === 401 || status === 403) {
      return { message: t('login.errorInvalidCredentials'), severity: 'error' };
    }
    if (status === 429) {
      return { message: t('login.errorTooManyAttempts'), severity: 'warning' };
    }
    if (status >= 500) {
      return { message: t('login.errorSystemTemporary'), severity: 'warning' };
    }
    // egyéb 4xx (400/404/422…) — a backend konkrét üzenete, ha van, különben generikus
    return { message: err.message || t('login.error'), severity: 'error' };
  }
  // nem-ApiError: hálózati / ismeretlen hiba (fetch TypeError, timeout stb.)
  return { message: t('login.errorNetwork'), severity: 'warning' };
}
